import { __assign } from "tslib";
import React, { useState } from "react";
import { Button, View } from "react-native";
import { PropagateLoader as Busy, ScaleLoader as Speaking, BounceLoader as Listening, PuffLoader as WaitingToSpeak } from "react-spinners";
var PnmacChatViz = function (props) {
  var _a = useState(true),
    loading = _a[0],
    setLoading = _a[1];
  var busySettings = props.busySettings || {
    size: 20
  };
  var waitSettings = props.waitSettings || {
    size: 45
  };
  var listenSettings = props.listenSettings || {
    size: 40
  };
  var speakSettings = props.speakSettings || {
    height: 30,
    width: 2,
    radius: 1,
    margin: 5
  };
  var _b = useState(busySettings.color || "#7ED321"),
    isBusyColor = _b[0],
    setIsBusyColor = _b[1];
  var _c = useState(waitSettings.color || "#00489D"),
    waitingToHearColor = _c[0],
    setWaitingToHearColor = _c[1];
  var _d = useState(listenSettings.color || "#D0021B"),
    listenColor = _d[0],
    setListenColor = _d[1];
  var _e = useState(speakSettings.color || "#4A90E2"),
    speakColor = _e[0],
    setSpeakColor = _e[1];
  return /*#__PURE__*/React.createElement(View, {
    className: "chat-viz-container row",
    style: {
      height: 50,
      width: "100%",
      flexDirection: "row"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 6,
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: props.currentState == "isBusy" ? "flex" : "none"
    }
  }, /*#__PURE__*/React.createElement(Busy, __assign({
    color: isBusyColor,
    loading: loading
  }, busySettings))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: props.currentState == "isSpeaking" ? "flex" : "none"
    }
  }, /*#__PURE__*/React.createElement(Speaking, __assign({
    color: speakColor,
    loading: loading
  }, speakSettings))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: props.currentState == "isListening" ? "flex" : "none"
    }
  }, /*#__PURE__*/React.createElement(Listening, __assign({
    color: listenColor,
    loading: loading
  }, listenSettings))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: props.currentState == "isWaitingForMicInput" ? "flex" : "none",
      paddingBottom: 5
    }
  }, /*#__PURE__*/React.createElement(WaitingToSpeak, __assign({
    color: waitingToHearColor,
    loading: loading
  }, waitSettings)))), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 2,
      flexDirection: "flex-end",
      padding: 10,
      display: props.userCanCancel ? "flex" : "none"
    }
  }, props.currentState != "blockSession" ? /*#__PURE__*/React.createElement(View, {
    style: {
      alignContent: "stretch",
      justifyContent: "space-evenly",
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Stop",
    onPress: props.resetChatState
  })) : /*#__PURE__*/React.createElement(View, null)));
};
export default PnmacChatViz;